import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

export function LineItemsNmfcQuestionBubble() {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">(Optional) NMFC Code</T>
          <T size="xs" color="secondary">
            If you have one, enter a 5-6 digit NMFC code here to help carriers
            understand the type of freight you are shipping more easily. With an
            NMFC code provided some carriers will be able to offer cheaper
            quotes.
          </T>
          <T size="xs" color="secondary">
            Using FreightSimple, you don&apos;t need to worry about the freight
            class (eg. 50, 70, 110, etc), since we calculate it for you.
          </T>
          <T size="xs" color="secondary">
            Our team can help you figure out the correct NMFC code for your
            shipment.
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/nmfc-codes-and-freight-class"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
}
